module.exports = __webpack_public_path__ + "img/verify-by-whatsapp.b8d777b4.svg";